import Box, { BoxProps } from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { EmtTheme } from "../types";

export type EmtFooterLinkProps = BoxProps & {
  nonce?: string;
};

const Link = styled(Box)(({ theme }: { theme?: EmtTheme }) => ({
  paddingTop: "10px",
  display: "flex",
  flexDirection: "column",
  gap: "5px",
  "& *": {
    color: theme?.palette.footer.linkColor,
  },
}));

export function EmtFooterLink(props: EmtFooterLinkProps) {
  return <Link {...props} />;
}
